export const BASE_URL = 'https://nodejs-admin.visamonde.com';
// https://nodejs-admin.visamonde.com
// http://localhost:3002

// Adresse publique des fichiers (demandes/, factures/) : suit BASE_URL, comme config/fichiers.js du backend
// local → Apache de WAMP (C:\wamp64\www\commons), prod → https://common.visamonde.com
export const FILES_BASE_URL = BASE_URL.includes('localhost')
  ? 'http://localhost/commons'
  : 'https://common.visamonde.com';

export const API_CONFIG = {
  baseUrl: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json', 
  },
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.baseUrl}${endpoint}`;
};

export const getAuthHeader = (societe?: string): Record<string, string> => {
  const tokenKey = societe === 'legrand' ? 'token_legrand' : 'token';
  const token = localStorage.getItem(tokenKey);

  if (token) {
    return {
      'Authorization': `Bearer ${token}`,
    };
  }
  return {};
};